import Alpine from 'alpinejs';
import Rellax from 'rellax';

Alpine.data('collapse', () => ({
    init() {
        let layers = this.$root.querySelectorAll('.layer');
        layers.forEach((el) => new Rellax(el, { center: true }));

        const wrapper = this.$root.querySelector('.text-wrapper');
        const text = this.$root.querySelector('.rich-text');
        let textHeight = text.getBoundingClientRect().height;

        setTimeout(() => {
            textHeight = text.getBoundingClientRect().height;
            wrapper.style.setProperty('--innerHeight', textHeight + 'px');
            wrapper.style.setProperty('--duration', textHeight + 'ms');
        }, 100);

        window.addEventListener('resize', () => {
            wrapper.style.setProperty('transition-property', 'none');
            textHeight = text.getBoundingClientRect().height;

            wrapper.style.setProperty('--innerHeight', textHeight + 'px');
            wrapper.style.setProperty('--duration', textHeight + 'ms');
            wrapper.style.setProperty('transition-property', null);
        });
    },

    toggleHeight() {},
}));
